import { SavedSearch } from '@creditsights/api-ui-web';
import {
  DATE_RELATIVE_RANGE_URL_KEY,
  END_DATE_URL_KEY,
  START_DATE_URL_KEY,
} from '../../components/FiltersBar/FiltersBar.logic';
import { AllFiltersData, FiltersOptions } from '../../components/FiltersSideBar/FiltersSideBar';
import { DATE_FORMATS, formatDate } from '../../utils/dateUtils';
import { SEARCH_TERM_URL_KEY } from './SearchResults.constants';
import { sanitizeElasticSearchStringValue } from '../../utils/sanitizeElasticSearchStringValue';

export const SortSearchKey = 'sortSearchKey';

export const getUrlSearchParams = (search: SavedSearch): URLSearchParams => {
  const searchParams = new URLSearchParams();

  search.filters.forEach((filter) => {
    filter.tags.forEach((tag) => {
      searchParams.append(filter.filterType, tag.tagId);
    });
  });

  if (search.dateRange?.relativeRange) {
    searchParams.set(DATE_RELATIVE_RANGE_URL_KEY, search.dateRange.relativeRange);
  } else {
    if (search.dateRange?.startDate) {
      searchParams.set(
        START_DATE_URL_KEY,
        formatDate(new Date(search.dateRange.startDate), DATE_FORMATS.YEAR_MONTH_DAY)
      );
    }

    if (search.dateRange?.endDate) {
      searchParams.set(END_DATE_URL_KEY, formatDate(new Date(search.dateRange.endDate), DATE_FORMATS.YEAR_MONTH_DAY));
    }
  }

  searchParams.set(SEARCH_TERM_URL_KEY, search.keywords!);

  if (search.sort) {
    searchParams.set('sort', search.sort);
  }

  if (search.tab) {
    searchParams.set('category', search.tab);
  }

  return searchParams;
};

export const updateTopicsSearchTermQuery = (searchTerm: string, tagsSearchList: string[]): string => {
  let updatedSearchTerm = '';
  for (let i = 0; i < tagsSearchList.length; i += 1) {
    if (i === 0) {
      // eslint-disable-next-line no-useless-escape
      updatedSearchTerm += `tags.tagId:\"${tagsSearchList[i]}\"`;
    } else {
      // eslint-disable-next-line no-useless-escape
      updatedSearchTerm += ` tags.tagId:\"${tagsSearchList[i]}\"`;
    }
  }
  if (searchTerm) {
    const searchTermTags = searchTerm.split(' ');
    for (let i = 0; i < searchTermTags.length; i += 1) {
      updatedSearchTerm += ` tags.name: ${sanitizeElasticSearchStringValue(searchTermTags[i])}`;
    }
  }

  return updatedSearchTerm;
};

export const findDisplayName = (options: FiltersOptions[], tagId: string): string => {
  for (const option of options) {
    if (option.tagId === tagId) {
      return option.displayName;
    }
    if (option.children) {
      for (const child of option.children) {
        if (child.tagId === tagId) {
          return child.displayName;
        }
      }
    }
  }
  return '';
};

export const searchFilterOptions = (type: string, allFiltersData: AllFiltersData[]): FiltersOptions[] => {
  for (const item of allFiltersData) {
    if (item.type === 'source' && (type === 'news_source' || type === 'covenants_source')) {
      return item.options;
    }
    if (item.type === type) {
      return item.options;
    }
  }
  return [];
};
